import React, { useEffect, useRef, useState } from "react";

export default function TVChart({ symbol = "BINANCE:BTCUSDT" }) {
  const containerId = `tv_chart_container_${symbol.replace(":", "_")}`;
  const containerRef = useRef(null);
  const [scriptLoaded, setScriptLoaded] = useState(false);

  useEffect(() => {
    if (window.TradingView) {
      setScriptLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/tv.js";
    script.async = true;
    script.onload = () => setScriptLoaded(true);
    document.head.appendChild(script);
  }, []);

  useEffect(() => {
    if (!scriptLoaded || !window.TradingView) return;

    new window.TradingView.widget({
      autosize: true,
      symbol,
      interval: "60",
      timezone: "Etc/UTC",
      theme: "dark",
      style: "1",
      locale: "zh",
      container_id: containerId,
      enable_publishing: false,
    });

    return () => {
      const el = document.getElementById(containerId);
      if (el) el.innerHTML = "";
    };
  }, [scriptLoaded, symbol, containerId]);

  return (
    <div
      ref={containerRef}
      id={containerId}
      className="w-full"
      style={{ height: 500 }}
    />
  );
}
